import { ImeModeKinds } from "../ImeModeKinds";
import { AbstractPlainTextItem } from "./AbstractPlainTextItem";
import { TypeKeys } from "./TypeKeys";
import { IImeControllable } from "./IImeControllable";
import { NumericFormatKinds } from "../NumericFormatKinds";
import { IEmptyValidatable } from "./IEmptyValidatable";
import { INameGroupEmptyValidatable } from "./INameGroupEmptyValidatable";
import { UserDefinitionWindowKinds } from "../UserDefinitionWindowKinds";
import { IUserDefinitionItem } from "./IUserDefinitionItem";
import { SelectionModeKinds } from "../SelectionModeKinds";
import { IHisInformationSelectable } from "./IHisInformationSelectable";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { PaintStyle, FontSizeCalculator } from "../../drawing";
import { IFontSizeAutoAdjustable } from "./IFontSizeAutoAdjustable";
import { IExtraPageRelationSettable } from "./IExtraPageRelationSettable";
import { DataValidationKinds } from "../DataValidationKinds";
import { ITextValidatable } from "./ITextValidatable";
import { AutoNotePageKinds } from "../AutoNotePageKinds";
import { SeparatorKinds } from "../SeparatorKinds";
import { HisItemParameter } from "../../his/behavior/HisItemParameter";
import { IExternalScriptAssociatable } from "./IExternalScriptAssociatable";
import { IRelatedExternalScriptExecutable } from "./IRelatedExternalScriptExecutable";
import { IPatientProfileInformationApplicable } from "./IPatientProfileInformationApplicable";
import { PatientProfileInformation } from "../../patient/PatientProfileInformation";
import { PatientProfileItem } from "../../patient/PatientProfileItem";
import { DateFormatter } from "../../system";
import { HisInformationTextValue, HisInformationDateTimeValue, IHisInformationValue } from "../../his/HisInformationValue";
import { IDesignatedDoctorNumberApplicable } from "./IDesignatedDoctorNumberApplicable";
import { AsteriskKinds } from "../AsteriskKinds";
import { INumericRangeValidatable } from "./INumericRangeValidatable";
import { NumericAlertKinds } from "../NumericAlertKinds";
import { NumericRangeValidator } from "../validators";
import { IPasteRequestable } from "./IPasteRequestable";
import { IPasteApplicable } from "./IPasteApplicable";
import { RelationalActionParameter } from "./RelationalActionParameter";
import { TextBoxInputMethodKinds } from "../inputMethodKinds/TextBoxInputMethodKinds";
import { IValueForCalculateExtractable } from "./IValueForCalculateExtractable";
import { NumericInputFormatter } from "../NumericInputFormatter";
import { TextBoxInputMethodOptionKinds } from "../inputMethodOptionKinds";
import { InitialSettingKinds } from "../InitialSettingKinds";
import { IInitialApplicable } from "./IInitialApplicable";
import { IMksTemplateExecutable } from "./IMksTemplateExecutable";
import { IDynamicTemplateExecutable } from "./IDynamicTemplateExecutable";
import { IQuotationRejecatable } from "./IQuotationRejecatable";
import { IHeightAutoAdjustable } from "./IHeightAutoAdjustable";
import { NumberingInformation } from "./NumberingInformation";
import { IItem } from "./IItem";
import { ObjectId } from "../ObjectId";
import { INumberingAssosiatable, instanceOfINumberingAssosiatable } from "./INumberingAssosiatable";
import { IJoinTextAssosiatable } from "./IJoinTextAssosiatable";
import { ISubNameSpecifiable } from "./ISubNameSpecifiable";
import { ITextCopyable } from "./ITextCopyable";
import { INaturalTextSpecifiable } from "./INaturalTextSpecifiable";
import { IClickChainRequestable } from "./IClickChainRequestable";

export class TextBoxItem extends AbstractPlainTextItem implements
  IImeControllable,
  IEmptyValidatable,
  IUserDefinitionItem,
  IHisInformationSelectable,
  IPaintableOnEditing,
  IFontSizeAutoAdjustable,
  IExtraPageRelationSettable,
  ITextValidatable,
  IExternalScriptAssociatable,
  IRelatedExternalScriptExecutable,
  IPatientProfileInformationApplicable,
  IDesignatedDoctorNumberApplicable,
  INumericRangeValidatable,
  INameGroupEmptyValidatable, // TODO: 本来はValuedItem辺りに実装すべき？今回は影響範囲を絞るためTextBoxItemに実装.
  IPasteRequestable,
  IPasteApplicable,
  IValueForCalculateExtractable,
  IInitialApplicable,
  IMksTemplateExecutable,
  IDynamicTemplateExecutable,
  IQuotationRejecatable,
  IHeightAutoAdjustable,
  INumberingAssosiatable,
  IJoinTextAssosiatable,
  ISubNameSpecifiable,
  ITextCopyable,
  INaturalTextSpecifiable,
  IClickChainRequestable {
  constructor(value: any) {
    super(TypeKeys.TextBoxItem, value);
  }

  public enableNameGroupEmptyCheck: boolean = false;  // TODO: 本来はValuedItem辺りに実装すべき？今回は影響範囲を絞るためTextBoxItemに実装.
  /** 入力方法 */
  public inputMethodKind: TextBoxInputMethodKinds = TextBoxInputMethodKinds.FreeInput;
  /** 入力方法の選択肢の種別 */
  public inputMethodOptionKind: TextBoxInputMethodOptionKinds = TextBoxInputMethodOptionKinds.Normal;
  public paintStyleOnEditing: PaintStyle = new PaintStyle();
  public imeMode: ImeModeKinds = ImeModeKinds.AllOn;
  public numericFormat: NumericFormatKinds = NumericFormatKinds.Invalid;
  public groupKey: string = "";
  public enableSingleEmptyCheck: boolean = false;
  public enableEmptyCheckConfirmation: boolean = false;
  public alertGroupKey: string = null;
  public userDefinitionKey: string = null;
  public userDefinitionSelectionMode: SelectionModeKinds = SelectionModeKinds.Row;
  public itemName: string = null;
  public userDefinitionWindowKind: UserDefinitionWindowKinds = null;
  /** HIS情報の項目か。 */
  public isHisInfo: boolean = false;
  /** HIS情報のデータがないとき表示される値。 */
  public displayName: string = null;
  public isNumeric: boolean = false;
  /** 一括入力時の識別子。 同一の識別子を持つ項目に対して値を入力する。 */
  public groupName: string = null;
  public subName: string = null;    // 転記で使用する模様
  public enabledAutoAdjustFontSize: boolean = false;
  public dataValidationKind: DataValidationKinds = null;
  public autoNotePageSize: number = null;
  public autoNotePageKind: AutoNotePageKinds = null;
  public separatorKind: SeparatorKinds = null;
  /** HIS情報 */
  public hisItemParameter: HisItemParameter = null;
  /** HIS情報を選択ダイアログからの入力を許可するかどうか */
  public isHisInfoSelectInputable: boolean = false;
  /** 続紙の値の格納先かどうか */
  public isNote: boolean = false;
  /** 続紙でどのオブジェクトから値を引っ張ってきているか */
  public relatedObjectKey: string = null;
  public relatedObjectName: string = null;
  public relatedObjectId: string = null;
  public relationObjectKey: string = null;
  public relationObjectName: string = null;
  public relationObjectId: string = null;
  /** 複数選択か */
  public isDialogMultiSelectable: boolean = false;
  /** 登録、または一時保存までの編集中の間、選択されている項目を保持する */
  public selectedItems: any[] = null;
  /** 指定医番号の種別(マスタとフォーマットに文字列で埋め込まれているので、enum対応はしない) */
  public designatedDoctorNumberType: string = null;
  /** 伏字の種類(PDFにどう表示するかどうか) */
  public asteriskKind: AsteriskKinds = null;
  /** 数値の上限値・下限値のチェック機能 */
  public numericAlertKind: NumericAlertKinds = null;
  public upperLimit: number = null;
  public lowerLimit: number = null;
  public upperLimitAlertColor: string = null;
  public lowerLimitAlertColor: string = null;
  public pasteDestinations: RelationalActionParameter[] = [];
  public parentAlertInformations: RelationalActionParameter[] = [];
  /** 初期値を設定するか */
  public isInitial: boolean;
  /** 初期値の種別（先頭:1/末尾:2/作成日:3） */
  public initialSettingKind: InitialSettingKinds;
  public shouldSelectHospitalizationInitialValueHospitalizedOnly: boolean;
  /** MKSテンプレート */
  public mksTemplateFormats: RelationalActionParameter[] = [];
  public mksTemplateRegisteredId: string = null;
  /** DYNAMICテンプレート */
  public dynamicTemplateFormats: RelationalActionParameter[] = [];
  public dynamicTemplateRegisteredId: string = null;
  /** 可変対応 */
  public originalHeight: number = null;
  public isFocusable: boolean = true;
  /** 採番用 */
  public numberingInformation: NumberingInformation = null;
  public numberingIdentifier: string = null;
  public originalNumberingIdentifier: string = null;
  public numberingIdentifierSources: RelationalActionParameter[] = [];
  public linkedValue: string;
  public userDefineLinkActions: RelationalActionParameter[] = [];
  public userDefineSearchActions: RelationalActionParameter[] = [];
  public isReadonlyFreeInput: boolean;
  public isNaturalViewEnable: boolean;
  public naturalText: string;
  public clickChainedObjectPrivateId: number;

  protected createCloneInstance(): TextBoxItem {
    return new TextBoxItem(this.originalValue);
  }

  protected applyMembers(clone: TextBoxItem): void {
    super.applyMembers(clone);
    clone.enableNameGroupEmptyCheck = this.cloneValue(this.enableNameGroupEmptyCheck);
    clone.inputMethodKind = this.cloneValue(this.inputMethodKind);
    clone.inputMethodOptionKind = this.cloneValue(this.inputMethodOptionKind);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
    clone.imeMode = this.cloneValue(this.imeMode);
    clone.numericFormat = this.cloneValue(this.numericFormat);
    clone.groupKey = this.cloneValue(this.groupKey);
    clone.enableSingleEmptyCheck = this.cloneValue(this.enableSingleEmptyCheck);
    clone.enableEmptyCheckConfirmation = this.cloneValue(this.enableEmptyCheckConfirmation);
    clone.alertGroupKey = this.cloneValue(this.alertGroupKey);
    clone.userDefinitionKey = this.cloneValue(this.userDefinitionKey);
    clone.userDefinitionSelectionMode = this.cloneValue(this.userDefinitionSelectionMode);
    clone.itemName = this.cloneValue(this.itemName);
    clone.userDefinitionWindowKind = this.cloneValue(this.userDefinitionWindowKind);
    clone.isHisInfo = this.cloneValue(this.isHisInfo);
    clone.displayName = this.cloneValue(this.displayName);
    clone.isNumeric = this.cloneValue(this.isNumeric);
    clone.groupName = this.cloneValue(this.groupName);
    clone.subName = this.cloneValue(this.subName);
    clone.enabledAutoAdjustFontSize = this.cloneValue(this.enabledAutoAdjustFontSize);
    clone.dataValidationKind = this.cloneValue(this.dataValidationKind);
    clone.autoNotePageSize = this.cloneValue(this.autoNotePageSize);
    clone.autoNotePageKind = this.cloneValue(this.autoNotePageKind);
    clone.separatorKind = this.cloneValue(this.separatorKind);
    clone.hisItemParameter = this.cloneValue(this.hisItemParameter);
    clone.isHisInfoSelectInputable = this.cloneValue(this.isHisInfoSelectInputable);
    clone.isNote = this.cloneValue(this.isNote);
    clone.relatedObjectKey = this.cloneValue(this.relatedObjectKey);
    clone.relatedObjectName = this.cloneValue(this.relatedObjectName);
    clone.relatedObjectId = this.cloneValue(this.relatedObjectId);
    clone.relationObjectKey = this.cloneValue(this.relationObjectKey);
    clone.relationObjectName = this.cloneValue(this.relationObjectName);
    clone.relationObjectId = this.cloneValue(this.relationObjectId);
    clone.isDialogMultiSelectable = this.cloneValue(this.isDialogMultiSelectable);
    clone.selectedItems = this.cloneValue(this.selectedItems);
    clone.designatedDoctorNumberType = this.cloneValue(this.designatedDoctorNumberType);
    clone.asteriskKind = this.cloneValue(this.asteriskKind);
    clone.numericAlertKind = this.cloneValue(this.numericAlertKind);
    clone.upperLimit = this.cloneValue(this.upperLimit);
    clone.lowerLimit = this.cloneValue(this.lowerLimit);
    clone.upperLimitAlertColor = this.cloneValue(this.upperLimitAlertColor);
    clone.lowerLimitAlertColor = this.cloneValue(this.lowerLimitAlertColor);
    clone.pasteDestinations = this.cloneValue(this.pasteDestinations);
    clone.parentAlertInformations = this.cloneValue(this.parentAlertInformations);
    clone.isInitial = this.cloneValue(this.isInitial);
    clone.initialSettingKind = this.cloneValue(this.initialSettingKind);
    clone.shouldSelectHospitalizationInitialValueHospitalizedOnly = this.cloneValue(this.shouldSelectHospitalizationInitialValueHospitalizedOnly);
    clone.mksTemplateFormats = this.cloneValue(this.mksTemplateFormats);
    clone.mksTemplateRegisteredId = this.cloneValue(this.mksTemplateRegisteredId);
    clone.dynamicTemplateFormats = this.cloneValue(this.dynamicTemplateFormats);
    clone.dynamicTemplateRegisteredId = this.cloneValue(this.dynamicTemplateRegisteredId);
    clone.originalHeight = this.cloneValue(this.originalHeight);
    clone.isFocusable = this.cloneValue(this.isFocusable);
    clone.numberingInformation = this.cloneValue(this.numberingInformation);
    clone.numberingIdentifier = this.cloneValue(this.numberingIdentifier);
    clone.originalNumberingIdentifier = this.cloneValue(this.originalNumberingIdentifier);
    clone.numberingIdentifierSources = this.cloneValue(this.numberingIdentifierSources);
    clone.linkedValue = this.cloneValue(this.linkedValue);
    clone.userDefineLinkActions = this.cloneValue(this.userDefineLinkActions);
    clone.userDefineSearchActions = this.cloneValue(this.userDefineSearchActions);
    clone.isReadonlyFreeInput = this.cloneValue(this.isReadonlyFreeInput);
    clone.isNaturalViewEnable = this.cloneValue(this.isNaturalViewEnable);
    clone.naturalText = this.cloneValue(this.naturalText);
    clone.clickChainedObjectPrivateId = this.cloneValue(this.clickChainedObjectPrivateId);
  }

  get shouldInputFree(): boolean {
    return this.inputMethodKind === TextBoxInputMethodKinds.FreeInput;
  }

  set shouldInputFree(value: boolean) {
    this.inputMethodKind = value
      ? TextBoxInputMethodKinds.FreeInput
      : TextBoxInputMethodOptionKinds.getDefualtInputMethodKind(this.inputMethodOptionKind);
  }

  get isEmpty(): boolean {
    return (this.value === undefined || this.value === null || this.value === "");
  }

  getGroupSelectKey(): string {
    return null;
  }

  setHisInfoItems(hisInfoValue: IHisInformationValue, shouldSkipInputMethodKindUpdate: boolean): void {
    const values 
      = (hisInfoValue instanceof HisInformationTextValue) ? hisInfoValue.data
      : (hisInfoValue instanceof HisInformationDateTimeValue) ? hisInfoValue.data.map(x => DateFormatter.format(x, hisInfoValue.format))
      : [];
    this.value = values.join(this.getDelimitor(this.separatorKind));
    if (!shouldSkipInputMethodKindUpdate) {
      this.changeToFreeInputWhenEmptyText();
    }
  }

  /** 入力されている値が空文字ならフリー入力に変更（固定文字、選択画面入力を除く） */
  private changeToFreeInputWhenEmptyText(): void {
    if (this.shouldChangeInputTypeToFreeInput) {
      this.inputMethodKind = TextBoxInputMethodKinds.FreeInput;
    }
  }

  /** 入力方法をフリー入力にするべきか */
  get shouldChangeInputTypeToFreeInput(): boolean {
    if (this.inputMethodOptionKind === TextBoxInputMethodOptionKinds.HisFreeInput) {
      return this.isEmpty;
    }
    return false;
  }

  setUserDefinitionValues(values: string[]): void {
    const delimitor = this.getDelimitor(this.separatorKind);
    this.value = values.join(delimitor);
  }

  public setText(text: string): void {
    this.value = text;
  }

  getValueForExternalScript(): string {
    return this.value;
  }

  setValueFromExternalScript(value: string): void {
    this.value = value;
  }

  setDesignatedDoctorNumber(value: string): void {
    this.value = value;
  }

  handlePatientProfileInformationApplied(info: PatientProfileInformation): boolean {
    if (!info || !info.items) { return false; }
    // TODO:V1の仕様の確認
    if (!this.name || !this.isEditable || this.isHisInfo) { return false; }
    const found = info.items.find(item => item.name === this.name);
    if (!found) { return false; }
    this.value = found.value;
    return true;
  }

  createPatientProfileItem(): PatientProfileItem {
    if (!this.name || this.isHisInfo) { return null; }
    const item = new PatientProfileItem();
    item.name = this.name;
    item.value = this.value;
    return item;
  }

  adjustFontSize(): void {
    if (!this.enabledAutoAdjustFontSize) { return; }
    const adjustedFontSize = this.getAdjustedFontSize(this.isMultiLine);
    this.textStyle.adjustedFontSize = adjustedFontSize;
  }

  get isMultiLine(): boolean {
    return this.textStyle.isMultiLine;
  }

  isNumericValueInRange(): boolean {
    const validateValue = this.getRangeValidateValue();
    return NumericRangeValidator.isInRange(validateValue, this.upperLimit, this.lowerLimit);
  }

  getNumericRangeAlertColor(): string {
    if (this.numericAlertKind !== NumericAlertKinds.Color) { return null; }
    const validateValue = this.getRangeValidateValue();
    if (!NumericRangeValidator.isInRange(validateValue, this.upperLimit, null)) {
      return this.upperLimitAlertColor;
    }
    if (!NumericRangeValidator.isInRange(validateValue, null, this.lowerLimit)) {
      return this.lowerLimitAlertColor;
    }
    return null;
  }

  private getRangeValidateValue(): any {
    return ((this.numericFormat === NumericFormatKinds.Money) && !!this.value && (typeof this.value === "string"))
      ? this.value.replace(/,/g, "")
      : this.value;
  }

  applyPastedValue(text: string, isChecked: boolean): void {
    this.value = text;
    this.adjustFontSize();
    this.adjustObjectHeight();
  }

  isPasteApplicable(isQuoting: boolean): boolean {
    return true;
  }

  pasteTo(item: IPasteApplicable): void {
    const text = this.valueToText(this.value);
    item.applyPastedValue(text, undefined);
  }

  isPasteKeyMatch(parameter: RelationalActionParameter): boolean {
    return (parameter.key === this.name && parameter.subKey === null);
  }

  get isSuppressionActive(): boolean {
    return this.isEmpty;
  }

  /**
   * 金額表示のカンマ対策
   */
  extractValueForCalculate(): any {
    return (this.value === null || this.value === undefined || typeof(this.value) === "number" || !this.isNumeric)
      ? this.value
      : NumericInputFormatter.toDigit(this.value);
  }

  isValueUpdated(item: any): boolean {
    if (!item) { return true; }
    if (this.isEmpty && item.isEmpty) { return false; }
    return this.value !== item.value;
  }

  isPatientProfileKeyMatched(key: string): boolean {
    return (this.name === key) && !this.isHisInfo;
  }

  changeInputMethodExceptUserDefinitionSelect(): void {
    this.inputMethodKind = TextBoxInputMethodKinds.FreeInput;
    this.linkedValue = "";
  }

  get shouldRejectQuotation(): boolean {
    // V1はeditが2でnameが空のオブジェクトを対象外としている模様。
    // 入力不可のフリー入力を引用・転記の対象とする必要があり、専用のフラグで判定している
    return !this.isFreeInputable && (this.groupKey === null || this.groupKey === undefined || this.groupKey === "") && !this.isReadonlyFreeInput;
  }

  getDisplayName(): string {
    if (this.userDefinitionKey && this.itemName) { return this.itemName; }
    return this.isHisInfo ? this.displayName : this.name;
  }

  shouldValidateText(): boolean {
    return this.isFreeInputable && this.inputMethodKind === TextBoxInputMethodKinds.FreeInput;
  }

  get shouldAutoAdjustHeight(): boolean {
    return (this.isRelayoutableByHeight && this.isMultiLine && !this.isNumeric);
  }

  adjustObjectHeight(): void {
    if (!this.isMultiLine || !this.shouldAutoAdjustHeight) { return; }
    this.geometry.rectangle.size.height = FontSizeCalculator.calculateObjectHeight(this);
  }

  rollbackValue(): void {
    if (this.inputMethodKind === TextBoxInputMethodKinds.None) {
      this.value = this.cloneValue(this.originalValue);
    }
  }

  initialize(
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem[]
  ): IItem {
    return this.getUpdatedClone<TextBoxItem>(
      s => super.initialize(itemAccessor, itemsAccessor) as TextBoxItem,
      s => s.createReevaluatedClone(itemAccessor, itemsAccessor),
    );
  }

  handleItemUpdated(
    originalItem: IItem,
    updatedItem: IItem,
    isInSameSection: boolean,
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]
  ): IItem {
    return this.getUpdatedClone<TextBoxItem>(
      s => super.handleItemUpdated(originalItem, updatedItem, isInSameSection, itemAccessor, itemsAccessor) as TextBoxItem,
      s => s.createReevaluatedCloneOnItemUpdated(updatedItem, itemAccessor, itemsAccessor),
    );
  }

  private createReevaluatedCloneOnItemUpdated(updatedItem: IItem, itemAccessor: (finder?: string | ObjectId | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem, itemsAccessor: (finder?: string | ObjectId | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]): TextBoxItem {
    if (!this.isReferedItem(updatedItem)) { return null; }
    return this.createReevaluatedClone(itemAccessor, itemsAccessor);
  }

  private createReevaluatedClone(itemAccessor: (finder?: string | ObjectId | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem, itemsAccessor: (finder?: string | ObjectId | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]): TextBoxItem {
    const numberingIdentifier = this.extractNumberingIdentifier(itemAccessor);
    if (this.numberingIdentifier === numberingIdentifier) { return null; }
    return this.createUpdatedClone<TextBoxItem>(s => s.numberingIdentifier = numberingIdentifier);
  }

  private extractNumberingIdentifier(itemAccessor: (finder?: string | ObjectId | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem): string {
    const texts: string[] = [];
    for (const source of this.numberingIdentifierSources) {
      const found = itemAccessor(new ObjectId(source.objectId));
      if (instanceOfINumberingAssosiatable(found)) {
        texts.push(found.getNumberingKeyword());
      }
      texts.push(source.value);
    }
    return texts.join("");
  }

  isReferedItem(updatedItem: IItem): boolean {
    if (!this.numberingIdentifierSources) { return false; }
    for (const source of this.numberingIdentifierSources) {
      if (source.objectId === updatedItem.id) { return true; }
    }
    return false;
  }

  setUserDefinitionLinkValues(values: string[]): void {
    if (!values || values.length === 0) {
      this.linkedValue = null;
      return;
    }
    // 複数選択された場合は、先頭の値を採用する（そもそもDMOのWebEditorは複数選択できない）
    this.linkedValue = values[0];
  }

  getNumberingKeyword(): string {
    // LinkActionsが指定されたユーザ定義がフリー入力になっている場合は、
    // 登録前にUserDefinitionLinkValueApplicatorでlinkedValueを格納している
    return (this.userDefineLinkActions.length === 0)
      ? this.text()
      : this.linkedValue;
  }

  setSelectedItems(items: any[]): void {
    this.selectedItems = items;
  }

  get textToCopy(): string {
    return this.valueToText(this.value);
  }

  get currentNaturalText(): string {
    return this.isNaturalViewEnable && this.naturalText
      ? this.naturalText
      : this.text();
  }

  isClickChained(clickChainIdentifier: string): boolean {
    return this.name === clickChainIdentifier;
  }
}
